export default {
      id: "lock-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#lock-usage",
      toString: function () {
        return this.url;
      }
    }